
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/forex/general",
      function () {
        return require("private-next-pages/help/forex/general.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/forex/general"])
      });
    }
  